import { useTranslations } from 'next-intl';

import { utilPluralize } from '@/fo/util/pluralize';

import { Question } from '../../types';
import { ReviewResponseCard } from '../ReviewResponseCard/ReviewResponseCard';

import { styles } from './QuestionCard.styles';

export interface QuestionCardProps {
  question: Question;
}

export function QuestionCard({ question }: QuestionCardProps) {
  const slots = styles();
  const t = useTranslations();

  const pluralizeAge = utilPluralize({
    one: t('pluralize.age.one'),
    few: t('pluralize.age.few'),
    many: t('pluralize.age.many')
  });

  const ageText = question.author.age
    ? `${question.author.age} ${pluralizeAge(question.author.age)}`
    : null;

  return (
    <div>
      <div className={slots.header()}>
        <span className={slots.author()}>
          {question.author.name}
          {ageText && ` / ${ageText}`}
          {question.author.skinType &&
            ` / ${question.author.skinType} ${t('skin')}`}
        </span>
        <span>{question.date}</span>
      </div>
      <div className={slots.text()}>{question.question}</div>

      <div className={slots.response()}>
        {question.response && (
          <ReviewResponseCard
            text={question.response.text}
            recommendedProduct={question.response.recommendedProduct}
          />
        )}
      </div>
    </div>
  );
}
